(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('premium-product')) {
    customElements.define('premium-product', class extends HTMLElement {
      connectedCallback() {
        this.mainImage = this.querySelector('[data-main-image]');
        this.variantId = this.querySelector('[data-variant-id]');
        this.price = this.querySelector('[data-current-price]');
        this.compareAtPrice = this.querySelector('[data-compare-at-price]');
        this.showCompareAt = this.querySelector('[data-product-price]')?.dataset.showCompareAt === 'true';
        this.buyButton = this.querySelector('button[name="add"]');
        this.buyButtonText = this.buyButton?.querySelector('.add-to-cart-text__content > span > span');
        this.productForm = this.querySelector('product-form-component');
        this.mobileTrack = this.querySelector('[data-mobile-track]');
        this.hideOtherVariantImages = this.querySelector('[data-product-gallery]')?.dataset.hideOtherVariantImages === 'true';
        this.variantRecords = Array.from(this.querySelectorAll('[data-variant-record]'));
        this.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.addEventListener('click', () => this.selectImage(button)));
        this.querySelectorAll('[data-option-radio]').forEach((radio) => radio.addEventListener('change', () => this.selectOption(radio)));
        const selectedVariant = this.variantRecords.find((record) => record.dataset.id === this.variantId?.value);
        if (this.mobileTrack) {
          const hasExplicitVariant = new URL(window.location.href).searchParams.has('variant');
          if (selectedVariant && hasExplicitVariant) {
            this.applyVariantMedia(selectedVariant, false);
          } else {
            this.mobileTrack.scrollLeft = Number(this.mobileTrack.dataset.initialIndex || 0) * this.mobileTrack.clientWidth;
          }
          this.mobileTrack.addEventListener('scroll', () => this.syncMobilePosition(), { passive: true });
        } else if (selectedVariant && new URL(window.location.href).searchParams.has('variant')) {
          this.applyVariantMedia(selectedVariant, false);
        }
      }
      selectImage(button) {
        if (this.mainImage) {
          this.mainImage.removeAttribute('srcset');
          this.mainImage.removeAttribute('sizes');
          this.mainImage.src = button.dataset.imageSrc;
          this.mainImage.alt = button.dataset.imageAlt || '';
        }
        if (this.mobileTrack) {
          const index = Number(button.dataset.mediaIndex || 0);
          this.mobileTrack.scrollTo({ left: index * this.mobileTrack.clientWidth, behavior: 'smooth' });
        }
        this.setActiveThumbnail(button.dataset.mediaIndex);
      }
      setActiveThumbnail(index) {
        this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
          const active = thumb.dataset.mediaIndex === String(index);
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }
      syncMobilePosition() {
        if (this.mobileFrame) cancelAnimationFrame(this.mobileFrame);
        this.mobileFrame = requestAnimationFrame(() => {
          const visibleSlides = Array.from(this.querySelectorAll('[data-mobile-slide]:not([hidden])'));
          const activeSlide = visibleSlides.reduce((closest, slide) => {
            if (!closest) return slide;
            return Math.abs(slide.offsetLeft - this.mobileTrack.scrollLeft) < Math.abs(closest.offsetLeft - this.mobileTrack.scrollLeft) ? slide : closest;
          }, null);
          if (activeSlide) this.setActiveThumbnail(activeSlide.dataset.mediaIndex);
        });
      }
      applyVariantMedia(variant, smooth = true) {
        const mediaId = variant.dataset.mediaId || '';
        if (this.hideOtherVariantImages) {
          this.querySelectorAll('[data-variant-media="true"]').forEach((item) => {
            item.hidden = item.dataset.mediaId !== mediaId;
          });
        }
        const activeThumb = this.querySelector(`[data-gallery-thumb][data-media-id="${mediaId}"]`);
        if (activeThumb) this.setActiveThumbnail(activeThumb.dataset.mediaIndex);
        const activeSlide = this.querySelector(`[data-mobile-slide][data-media-id="${mediaId}"]`);
        if (this.mobileTrack && activeSlide) {
          this.mobileTrack.scrollTo({ left: activeSlide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        }
      }
      selectOption(radio) {
        const fieldset = radio.closest('[data-product-option]');
        const selection = fieldset?.querySelector('[data-option-selection]');
        if (selection) selection.textContent = radio.value;
        fieldset?.querySelectorAll('.premium-product__variant').forEach((label) => label.classList.toggle('is-active', label.contains(radio)));

        const selectedOptions = Array.from(this.querySelectorAll('[data-product-option]')).map((option) => option.querySelector('[data-option-radio]:checked')?.value || '');
        const variant = this.variantRecords.find((record) => {
          try {
            return JSON.parse(record.dataset.options || '[]').every((value, index) => value === selectedOptions[index]);
          } catch (_error) {
            return false;
          }
        });

        this.selectVariant(variant);
      }
      selectVariant(variant) {
        if (!variant) {
          if (this.buyButton) this.buyButton.disabled = true;
          if (this.buyButtonText) this.buyButtonText.textContent = this.productForm?.dataset.unavailableLabel || 'Unavailable';
          return;
        }

        if (this.variantId) this.variantId.value = variant.dataset.id;
        if (this.price) this.price.textContent = variant.dataset.price;
        if (this.compareAtPrice) {
          this.compareAtPrice.textContent = variant.dataset.compareAtPrice || '';
          this.compareAtPrice.hidden = !(this.showCompareAt && variant.dataset.compareActive === 'true');
        }
        const available = variant.dataset.available === 'true';
        if (this.buyButton) this.buyButton.disabled = !available;
        if (this.buyButtonText) this.buyButtonText.textContent = available ? this.productForm?.dataset.availableLabel : this.productForm?.dataset.soldOutLabel;
        if (variant.dataset.imageSrc && this.mainImage) {
          this.mainImage.removeAttribute('srcset');
          this.mainImage.removeAttribute('sizes');
          this.mainImage.src = variant.dataset.imageSrc;
        }
        const addToCart = this.querySelector('add-to-cart-component');
        if (addToCart && variant.dataset.imageSrc) addToCart.dataset.productVariantMedia = variant.dataset.imageSrc;
        this.applyVariantMedia(variant);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.dataset.id);
        window.history.replaceState({}, '', url);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-signature-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('premium-product-card')) {
    customElements.define(
      'premium-product-card',
      class PremiumProductCard extends HTMLElement {
        connectedCallback() {
          this.image = this.querySelector('.premium-product-card__main-image');
          if (!this.image) return;

          this.originalSrc = this.image.getAttribute('src');
          this.originalSrcset = this.image.getAttribute('srcset');

          this.querySelectorAll('[data-variant-image]').forEach((thumbnail) => {
            thumbnail.addEventListener('pointerenter', () => this.preview(thumbnail));
            thumbnail.addEventListener('pointerleave', () => this.reset());
            thumbnail.addEventListener('focus', () => this.preview(thumbnail));
            thumbnail.addEventListener('blur', () => this.reset());
          });
        }

        preview(thumbnail) {
          const source = thumbnail.dataset.variantImage;
          if (!source) return;
          this.image.setAttribute('srcset', '');
          this.image.setAttribute('src', source);
        }

        reset() {
          this.image.setAttribute('src', this.originalSrc);
          if (this.originalSrcset) {
            this.image.setAttribute('srcset', this.originalSrcset);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
